export class Transaction {
  datetime: string;
  operation: string;
  amount: number;
}
